module.exports = __webpack_public_path__ + "static/media/cybercrime@3x.9fabfc86.png";